export default __webpack_public_path__ + "static/media/100_19783.4a1ea794.jpg";